/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                 from '@/util/i.command';
import {TSO}                      from '@/models/scenario/t.s.o';
import {TSOChange}                from '@/screens/ide/tso/t.s.o.change';
import {TSOEditorComponent}       from '@/components/t.s.o.editor.component';
import {Logger}                   from '@/util/logger';
import {TSOSpeed}                 from "@/models/scenario/t.s.o.speed";
import {Track}                    from '@/models/scenario/track';

/**
 *
 * @class AddTSOCommand
 *
 * @brief reversible addition of a train slow order
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2020
 *
 */
export class AddTSOCommand implements ICommand {

  private readonly newValue: TSOChange = null;
  private   editor: TSOEditorComponent = null;
  private   newTSO: TSO                = null;

    constructor(newValue: TSOChange, editor: TSOEditorComponent) {

    this.newValue = newValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    /* assign id/create the new tso */

    if (this.newTSO == null) {

      const input: TSOChange = this.newValue.snapshot;
      const    id: number    = this.editor.scenario.allocateTSOId();

      this.newTSO            = new TSO(
        id,
        input.name,
        input.description,
        input.start.asSeconds(),
        input.duration.asSeconds(),
        input.tonnage,
        input.eastMile,
        input.eastDP,
        input.westMile,
        input.westDP,
        -1
      );

      /* deep copy the freight speeds */

      this.newTSO._frtSpeed = input.frtSpeed;

      this.newTSO.setClasses('FRT', input.frtClasses);

      /* deep copy the passenger speeds */

      this.newTSO._psgSpeed = input.psgSpeed;

      this.newTSO.setClasses('PSG', input.psgClasses);

      /* deep copy the links */

      const links: Track[] = this.editor.scenario.westBoundBetween(input.eastMile, input.westMile);

      this.newTSO.setLinks(links);

    }

    Logger.debug('[tso/table:add] saving ', this.newTSO);

    /* save it to the scenario */

    this.editor.scenario.tso().set(this.newTSO._id, this.newTSO);

    /* refresh the views */

    this.editor.table.refreshTable();

    Logger.debug('[tso/table:add] refreshed.');

    /* clear the view selections */

    this.editor.table.doSelection(null);
    this.editor.editor.clear();

    Logger.debug('[tso/table:add] selection cleared.');
  }

  /** reverse the command's effects */
  unExecute() {

    /* delete the block that was added */

    Logger.debug('[tso/table:add] deleting ', this.newTSO);

    this.editor.scenario.tso().delete(this.newTSO._id);

    /* refresh the views (so the block disappears) */

    this.editor.table.refreshTable();

    Logger.debug('[tso/table:add] refreshed.');

    /*
     * (re)select what was selected when we added, this brings back the
     * selection, and the the edit inputs as they were just before the
     * add.
     *
     */

    this.editor.table.doSelection(this.newValue);

  }

  /** return a string summary of this command */
  asString(): string {

    const b = (this.newValue instanceof TSOChange) ? this.newTSO._id : '';

    return '[tso/table:add] ' + b;
  }

}
